"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Settings = require("./Settings");
Object.keys(_Settings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Settings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Settings[key];
    }
  });
});